import React, {useEffect, useState} from 'react';
import DropDown from '../../../commonComponents/Forms/dropDown';
import {trackMoengageEvent} from '../../../utils/commonMethods';
import {globalFontStyle} from '../../../assets';

function Category(props) {
  const {globalConfigData, sortSelectValue, onSortPress} = props;
  const [sortingData, setSortingData] = useState([]);

  useEffect(() => {
    if (globalConfigData?.sortingOptions) {
      const modifiedArray = globalConfigData?.sortingOptions.map(item => {
        return {label: item?.Title, value: item?.Id};
      });
      setSortingData(modifiedArray);
      onSortPress(modifiedArray[0].value);
    }
  }, [globalConfigData?.sortingOptions?.length]);

  const onSortChange = selectedItemId => {
    onSortPress(selectedItemId);
    trackMoengageEvent('Clicked on Sort', {
      page: 'home',
      Option: sortingData.filter(item => item.Id === selectedItemId)?.[0]
        ?.Title,
    });
  };

  return (
    <>
      {sortingData.length > 0 && (
        <DropDown
          label="Select Duration"
          selectedData={sortSelectValue}
          onValueChange={onSortChange}
          pickerlist={sortingData}
          customStyle={{
            container: {
              height: 28,
              borderRadius: 4,
              backgroundColor: '#EEEEEE',
              borderWidth: 1,
              borderColor: 'transparent',
              paddingHorizontal: 12,
              minWidth: 20,
              justifyContent: 'center',
              alignItems: 'center',
              boxShadow: '0 1px 2px rgba(0,0,0,0.05)',
              transition: 'all 0.2s ease',
              marginRight: 0,
            },
            text: {
              ...globalFontStyle.appFontRegular,
              color: '#666666',
              fontSize: 13,
              fontWeight: '500',
              letterSpacing: '0.1px',
              textAlign: 'left',
            },
            icon: {
              marginLeft: 8,
              width: 12,
              height: 12,
              opacity: 0.7,
            },
            dropdown: {
              backgroundColor: '#FFFFFF',
              borderRadius: 4,
              boxShadow: '0 2px 4px rgba(0,0,0,0.08)',
              borderColor: '#E0E0E0',
            },
            selectedItem: {
              backgroundColor: '#000000',
              color: '#FFFFFF',
            }
          }}
        />
      )}
    </>
  );
}

export default Category;
